import React, { Component } from "react";
import moment from 'moment';
import { Select, Input } from "antd";
import { map } from 'lodash';
import DataTable from './Datatable';
import Loader from "../../Common/Component/Loader";
import { DatePicker, Checkbox, Table } from "antd";
import { aboutUsData } from "../../../Assets/data/aboutUsList";

const { Option } = Select;
const { RangePicker } = DatePicker;
class ReportSidebar extends Component {
  state = {
    errors: {},
    loader: false,
    customerList: [],
    defaultValue: '',
    customerId: '',
    endDate: moment().format('YYYY-MM-DD'),
    startDate: moment().subtract(1, 'years').format('YYYY-MM-DD'),
    invoiceStartDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    reportEndDate: moment().endOf('month').format('YYYY-MM-DD'),
    reportStartDate: moment().startOf('month').format('YYYY-MM-DD'),
    franchise_list: [],
    franchiseList:[],
    authUser: JSON.parse(localStorage.getItem('authUser')),
    selectedFranchises: ["All"],
    searchValue: "",
    type:'',
    isCheck: false,
    userRole: '',
    satisfactionScore:'',
    lastComplaint:'',
    defaultCustomer : '',
    firstServiceStartDate: null,
    firstServiceEndDate: null,
    periodStartDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    periodEndDate: moment().format('YYYY-MM-DD'),
    cancellationReason: '',
    summaryReports:[],
    total_cancelation_customer: 0,

    // Lead & Sign Up Report
    customer_type: '',

    // Residential Lead Secondary Filters
    stage: '',
    zipcodes: '',
    channels: [],
    outreach: ['all'],
    leadStage: ['all'],
    frequency: ['all'],
    leadStatus: ['all'],
    hearAboutUs: ['all'],
    satisfactionScore: '',
    lastContactEndDate: '',
    lastServiceStartDate: '',
    lastContactStartDate: '',
    leadCretionStartDate: '',
    joinedEndDate: moment().endOf('month').format('YYYY-MM-DD'),
    joinedStartDate: moment().startOf('month').format('YYYY-MM-DD'),
    leadCretionEndDate: moment().endOf('month').format('YYYY-MM-DD'),
    lastServiceEndDate: moment().endOf('month').format('YYYY-MM-DD'),

    // Commercial Proposal & Sign Up Report
    // Secondary Filters
    propertyType: ['all'],
    communityRole: ['all'],
    serviceProduct: ['all'],
    channelAttribution: ['all'],
    leadCreationEndDate: moment().endOf('month').format('YYYY-MM-DD'),
    leadCreationStartDate: moment().startOf('month').format('YYYY-MM-DD'),

    // Coupon Code Report
    couponType: ['all'],
    defaultCouponCodeFranchise:[],
    //prise increase report
    joined: 'all',
    customJoinedStartDate: null,
    customJoinedEndDate: null,
    last_increase_endDate: null,
    last_increase_startDate: null,
  };

  componentDidMount = () => {
    this.props.getFranchise();
    const is_franchise_owner = this.state.authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");
      if(is_franchise_owner){
        this.renderDefaultFranchiseFoInCR(this.state.authUser,this.state.franchise_list,is_franchise_owner);
      }

    if(this.props.id === 'lead_signup_report')
    {
      this.props.getChannelsCatalog();
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { authUser, franchise_list, } =this.state;
    const is_franchise_owner = authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");

    if(nextProps?.customerList && Object.keys(nextProps?.customerList).length > 0 
      && nextProps?.customerList !== this.props?.customerList) {
      this.setState({defaultCustomer : nextProps?.customerList?.[0]?.uuid});
    }

    if(nextProps?.summaryReports && Object.keys(nextProps?.summaryReports).length > 0 
      && nextProps?.summaryReports !== this.state?.summaryReports) {
      this.setState({
        summaryReports : nextProps?.summaryReports?.cancelation_customer_summary,
        total_cancelation_customer: nextProps?.summaryReports?.total_cancelation_customer
      })
    }

    if(nextProps?.Setting?.franchise && Object.keys(nextProps?.Setting?.franchise).length > 0
      && nextProps.Setting?.franchise !== this.nextProps?.Setting?.franchise)
    {
      this.setState({franchise_list: nextProps?.Setting?.franchise?.results});
    }

    if(nextProps?.Channels && Object.keys(nextProps?.Channels?.data).length > 0 
      && nextProps?.Channels?.data !== this.state?.Channels?.data) {
      
      this.setState({ channels : nextProps?.Channels?.data?.results });
    }

    // Code to show default Franchise in Coupon code farnchise dropdown for FO
    if(this.props.id == "coupon_report" || this.props.id == "lead_signup_report"){
      if(is_franchise_owner){
        this.renderDefaultFranchiseFoInCR(authUser,franchise_list,is_franchise_owner);
      }
    }

    this.setState({loader: false});
  }

  setInvoiceRange = (e) => {
    if(e){
      this.setState({
        startDate:moment(e[0]).format('YYYY-MM-DD'),
        endDate: moment(e[1]).format('YYYY-MM-DD')
      })
    } else{
      this.setState({
        startDate: null, //moment().subtract(1, 'years').format('YYYY-MM-DD'),
        endDate: null //moment().format('YYYY-MM-DD')
      })
    }
  }
  setLastIncrease = (e) => {
    if(e){
      this.setState({
        last_increase_startDate: moment(e[0]).format('YYYY-MM-DD'),
        last_increase_endDate: moment(e[1]).format('YYYY-MM-DD'),
      })
    } else{
      this.setState({
        last_increase_startDate: null, //moment().subtract(1, 'years').format('YYYY-MM-DD'),
        last_increase_endDate: null //moment().format('YYYY-MM-DD')
      })
    }
  }

  setReportDateRange = (e, type) => {
    const filters = { 
      ...this.props.filters,
      start_date: e ? moment(e[0]).format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD'),
      end_date: e ? moment(e[1]).format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD')
    };

    if(type === 'coupon-report')
    {
      filters.start_date = e ? moment(e[0]).format('YYYY-MM-DD') : null;
      filters.end_date = e ? moment(e[1]).format('YYYY-MM-DD') : null;
    }

    this.setState({
      reportEndDate: filters.end_date,
      reportStartDate: filters.start_date
    });
  }

  setDateRangeChange = (e, type) => {
    const filters = { 
      ...this.props.filters,
    };

    switch(type)
    {
    case 'lead_creation':
      this.setState({
        filters,
        leadCreationStartDate: e ? moment(e[0]).format('YYYY-MM-DD') : null,
        leadCreationEndDate: e ? moment(e[1]).format('YYYY-MM-DD') : null
      });
      break;
    case 'last_contact':
      this.setState({
        filters,
        lastContactStartDate: e ? moment(e[0]).format('YYYY-MM-DD') : null,
        lastContactEndDate: e ? moment(e[1]).format('YYYY-MM-DD') : null
      });
      break;
    case 'joined':
      this.setState({
        filters,
        joinedStartDate: e ? moment(e[0]).format('YYYY-MM-DD') : null,
        joinedEndDate: e ? moment(e[1]).format('YYYY-MM-DD') : null
      });
      break;
    case 'last_serviced':
      this.setState({
        filters,
        lastServiceStartDate: e ? moment(e[0]).format('YYYY-MM-DD') : null,
        lastServiceEndDate: e ? moment(e[1]).format('YYYY-MM-DD') : null
      });
    }
  }

  onMultiSelectChange = (e, type) => {
    let selection = e;

    if (e.length > 1 && e[0] ==="all")
    {
      selection = e.filter(item => item !== "all");
    }
    else if (e.length === 0 || (e.length > 0 && e.includes('all')))
    {
      selection = ["all"];
    }

    this.setState({[type]: selection});
  }

  onBuildReport = () =>
  {
    const {
      authUser,
      stage,
      zipcodes,
      outreach,
      frequency,
      leadStage,
      leadStatus,
      couponType,
      hearAboutUs,
      propertyType,
      customer_type,
      joinedEndDate,
      franchise_list,
      joinedStartDate,
      leadCreationEndDate,
      leadCreationStartDate,
      lastServiceEndDate,
      lastServiceStartDate,
      lastContactEndDate,
      lastContactStartDate,
      selectedFranchises,
      reportEndDate,
      reportStartDate,
      channelAttribution,
      cancellationReason,
      defaultValue,
      periodStartDate,
      periodEndDate
    } = this.state;

    let filters;
    const is_franchise_owner = authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");
    let are_all_franchises_selected = selectedFranchises.includes("All") || selectedFranchises.includes("all");

    switch(this.props.id)
    {
      case 'lead_signup_report':
        if(customer_type === '')
        {
          this.setState({errors: {customer_type: 'Please select a customer type for build the report'}});
            return;
        } 
        if(stage === '')
        {
          this.setState({errors: {stage: 'Please select a stage for build the report'}});
          return;
        }
        else if(customer_type === 'commercial')
        {
          if(stage === 'lead')
          {
              filters = {
                stage,
                customer_type,
                ...filters,
              };

              if(leadCreationStartDate && leadCreationStartDate !== '')
              {
                filters = {
                  ...filters,
                  created_at__gte: moment(leadCreationStartDate).format('YYYY-MM-DDT00:00:00'),
                  created_at__lte: moment(leadCreationEndDate).format('YYYY-MM-DDT23:59:59'),
                }
              }
              
              if(!propertyType.includes('all'))
              {
                filters = {
                  ...filters,
                  properties_in_community: propertyType.join(',')
                }
              }

              if(!outreach.includes('all'))
              {
                filters = {
                  ...filters,
                  outreach: outreach.join(','),
                }
              }

              if(!hearAboutUs.includes('all'))
              {
                filters = {
                  ...filters,
                  hear_about_us: hearAboutUs.join(','),
                }
              }

              if(!channelAttribution.includes('all'))
              {
                filters = {
                  ...filters,
                  channel_attribution__uuid: channelAttribution.join(',')
                }
              }

              if(!are_all_franchises_selected)
              {
                filters = {
                  field_office__uuid__in: selectedFranchises.join(','),
                  ...filters
                }
              }

              if(are_all_franchises_selected && is_franchise_owner)
              {
                filters = {
                  field_office__uuid__in: franchise_list.map(item => item.uuid).join(','),
                  ...filters
                }
              }

              this.props.setStageAndCustomer(stage, customer_type);
          }
          else if(stage ==='signup')
          {
            filters = {
              stage,
              customer_type,
              ...filters,
            };

            if(joinedStartDate && joinedStartDate !== '')
            {
              filters = {
                created_at__gte: moment(joinedStartDate).format('YYYY-MM-DDT00:00:00'),
                created_at__lte: moment(joinedEndDate).format('YYYY-MM-DDT23:59:59'),
                ...filters,
              };
            }
            
            if(!propertyType.includes('all'))
            {
              filters = {
                ...filters,
                properties_in_community: propertyType.join(',')
              }
            }

            if(!hearAboutUs.includes('all'))
            {
              filters = {
                ...filters,
                hear_about_us: hearAboutUs.join(','),
              }
            }

            if(!channelAttribution.includes('all'))
            {
              filters = {
                ...filters,
                channel_attribution__uuid: channelAttribution.join(',')
              }
            }

            if(!frequency.includes('all'))
            {
              filters = {
                ...filters,
                frequency: frequency.join(',')
              }
            }

            if(!are_all_franchises_selected)
            {
              filters = {
                commercial_profile__field_office__uuid__in: selectedFranchises.join(','),
                ...filters
              }
            }

            if(are_all_franchises_selected && is_franchise_owner)
              {
                filters = {
                  field_office__uuid__in: franchise_list.map(item => item.uuid).join(','),
                  ...filters
                }
              }

            this.props.setStageAndCustomer(stage, customer_type);
          }
        }
        else if(customer_type === 'residential')
        {
          if(stage === 'lead')
          {
            if(!are_all_franchises_selected)
            {
              filters = {
                field_office_uuids: selectedFranchises,
              };
            }

            filters = {
                ...filters,
                stage,
                leadStatus,
                outreach,
                leadStage,
                hearAboutUs,
                customer_type,
                channelAttribution,
                leadCreationEndDate,
                leadCreationStartDate,
                lastContactEndDate,
                lastContactStartDate,
            };

            this.props.setStageAndCustomer(stage, customer_type);
          }
          else if(stage ==='signup')
          {
            if(!are_all_franchises_selected)
            {
              filters = {
                field_office_uuids: selectedFranchises,
              };
            }

            filters = {
                ...filters,
                stage,
                zipcodes,
                outreach,
                frequency,
                hearAboutUs,
                customer_type,
                joinedEndDate,
                joinedStartDate,
                channelAttribution,
                lastServiceEndDate,
                lastServiceStartDate,
            };

            this.props.setStageAndCustomer(stage, customer_type);
          }
        }
      break;
      case 'customer-cancelation-report':
      {
        filters = {
          ordering: "first_name",
          ...filters,
        };

        if(cancellationReason && cancellationReason !== '')
        {
          filters = {
            cancelation_reason: cancellationReason,
            ...filters,
          };
        }

        if(!are_all_franchises_selected)
        {
          filters = {
            field_office__uuid__in: selectedFranchises.join(','),
            ...filters
          }
        }

        if(are_all_franchises_selected && is_franchise_owner)
        {
          filters = {
            field_office__uuid__in: franchise_list.map(item => item.uuid).join(','),
            ...filters
          }
        }

        if(periodStartDate && periodStartDate !== '')
        {
          filters = {
            cancelation_date__gte: moment(periodStartDate).format('YYYY-MM-DDT00:00:00'),
            cancelation_date__lte: moment(periodEndDate).format('YYYY-MM-DDT23:59:59'),
            ...filters
          }
        }
      }
      break;
      case 'coupon_report':
        if(!are_all_franchises_selected)
        {
          filters = {
            field_office_uuids: selectedFranchises,
          };
        }
        
        if(reportStartDate && reportStartDate !== '')
        {
          filters = {
            start_date: reportStartDate,
            end_date: reportEndDate,
            created_at__gte: moment(reportStartDate).format('YYYY-MM-DDT23:59:59'),
            created_at__lte: moment(reportEndDate).format('YYYY-MM-DDT23:59:59'),
            ...filters
          }
        }
        
        if(are_all_franchises_selected && is_franchise_owner)
        {
          filters = {
            field_office__uuid__in: franchise_list.map(item => item.uuid).join(','),
            ...filters
          }
        }
        filters = {
          ...filters,
          couponType,
        };
      break;
      default:
        if(!are_all_franchises_selected)
        {
          filters = {
            field_office_uuids: selectedFranchises,
          };
        }
        
        if(reportStartDate && reportStartDate !== '')
        {
          filters = {
            start_date: reportStartDate,
            end_date: reportEndDate,
            created_at__gte: moment(reportStartDate).format('YYYY-MM-DDT00:00:00'),
            created_at__lte: moment(reportEndDate).format('YYYY-MM-DDT23:59:59'),
            ...filters
          }
        }

        if(are_all_franchises_selected && is_franchise_owner)
        {
          filters = {
            field_office__uuid__in: franchise_list.map(item => item.uuid).join(','),
            ...filters
          }
        }
        else if(!reportStartDate && reportStartDate === '')
        {
          filters = {
            created_at__gte: moment(reportStartDate).format('YYYY-MM-DDT00:00:00'),
            created_at__lte: moment(reportEndDate).format('YYYY-MM-DDT23:59:59'),
          };
        }
    }

    this.props.onFiltersUpdate(filters);
  }

  resetFilters = (is_stage = false, is_customer_type = false) =>
  {
    switch(this.props.id)
    {
      case 'lead_signup_report':
        if(is_customer_type)
        {
          this.setState({
            stage: '',
            zipcodes: '',
            leadStatus: ['all'],                             
            outreach: ['all'],
            leadStage: ['all'],
            frequency: ['all'],
            lastContact: ['all'],
            hearAboutUs: ['all'],
            lastContactEndDate: null,
            lastServiceEndDate: null,
            lastContactStartDate: null,
            lastServiceStartDate: null,
            channelAttribution: ['all'],
            reportEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            reportStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            joinedEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            joinedStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            leadCreationEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            leadCreationStartDate: moment().startOf('month').format('YYYY-MM-DD'),
          });
        }
        else if(is_stage)
        {
          this.setState({
            zipcodes: '',
            outreach: ['all'],
            leadStage: ['all'],
            frequency: ['all'],
            leadStatus: ['all'],
            lastContact: ['all'],
            hearAboutUs: ['all'],
            propertyType: ['all'],
            lastContactEndDate: null,
            lastServiceEndDate: null,
            lastContactStartDate: null,
            lastServiceStartDate: null,
            channelAttribution: ['all'],
            reportEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            reportStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            joinedEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            joinedStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            leadCreationEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            leadCreationStartDate: moment().startOf('month').format('YYYY-MM-DD'),
          });
        }
        else
        {
          this.setState({
            selectedFranchises: ["All"],
            stage: '',
            zipcodes: '',
            leadStatus: ['all'],
            outreach: ['all'],
            leadStage: ['all'],
            frequency: ['all'],
            lastContact: ['all'],
            hearAboutUs: ['all'],
            lastContactEndDate: null,
            lastServiceEndDate: null,
            lastContactStartDate: null,
            lastServiceStartDate: null,
            channelAttribution: ['all'],
            reportEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            reportStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            joinedEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            joinedStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            leadCreationEndDate: moment().endOf('month').format('YYYY-MM-DD'),
            leadCreationStartDate: moment().startOf('month').format('YYYY-MM-DD'),
          });
        }
      break;
    }
  }

  setFirstServiceRange = (e) => {
    if(e){
      this.setState({
        firstServiceStartDate:moment(e[0]).format('YYYY-MM-DD'),
        firstServiceEndDate: moment(e[1]).format('YYYY-MM-DD')
      })
    } else{
      this.setState({
        firstServiceStartDate: null, //moment().subtract(1, 'years').format('YYYY-MM-DD'),
        firstServiceEndDate: null //moment().format('YYYY-MM-DD')
      })
    }
  }

  setTimePeriod = (e) => {
    if(e){
      this.setState({
        endDate: moment(e).format('YYYY-MM-DD')
      })
    }
  }

  customerChange = (e) => {
    const { customerList } = this.props
    if(e){
      this.setState({
        customerId: e
      })
      this.props.updateCustomerDetails({
        customerId: e
      })
    } else{
      this.setState({
        customerId: customerList[0].uuid
      })
      this.props.updateCustomerDetails({
        customerId: customerList[0].uuid
      })
    }
  }

  franchiseChange = (e) => {
    this.setState({defaultValue: e});
  }

  userRoleChange = (e) => {
    this.setState({userRole: e});
  }
  
  changeTimePeriodRange = (type,e) => {
    if(e && type === "invoice" ) {
      this.setState({
        invoiceStartDate: moment(e[0]).format('YYYY-MM-DD'),
        endDate: moment(e[1]).format('YYYY-MM-DD')
      });

    } else if(!e) {
      this.setState({
        invoiceStartDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD')
      });
    }else{
      this.setState({
        startDate: moment(type[0]).format('YYYY-MM-DD'),
        endDate: moment(type[1]).format('YYYY-MM-DD')
      });
    }
  }

  changePeriodDateRange = (type,e) => {
    if(e && type==="period") {
      this.setState({
        periodStartDate: moment(e[0]).format('YYYY-MM-DD'),
        periodEndDate: moment(e[1]).format('YYYY-MM-DD')
      });
    }else{
      this.setState({
        startDate: moment(type[0]).format('YYYY-MM-DD'),
        endDate: moment(type[1]).format('YYYY-MM-DD')
      });
    }
  }

  joinedChange = (e) => {
    this.setState({
      joined: e,
    });
    if(e !== 'custom'){
      this.setState({
        customJoinedStartDate: null,
        customJoinedEndDate: null,
      });
    }
  };
  customJoinedDateChange = (e)=>{
    if(e) {
      this.setState({
        customJoinedStartDate: moment(e[0]).format('YYYY-MM-DD'),
        customJoinedEndDate: moment(e[1]).format('YYYY-MM-DD')
      });
    }else{
      this.setState({
        customJoinedStartDate: null,
        customJoinedEndDate: null,
      });
    }
  }
  satisfactionScoreChange = (e) => {
    this.setState({
      satisfactionScore: e,
    });
  };

  lastComplaintChange = (e) => {
    this.setState({
      lastComplaint: e,
    });
  };

  onSelectedFranchisesChange = (e) => {
    const {authUser} = this.state;
    const is_franchise_owner = this.state.authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");
    const isRemoveAll = is_franchise_owner && this.props.id == "coupon_report" ? true : false;

    let selection = e;

    if (e.length > 1 && e[0] ==="All")
    {
      selection = e.filter(item => item !== "All");
    }
    else if (e.length === 0 || (e.length > 0 && e.includes('All')))
    {
      selection = ["All"];
    }
    selection = isRemoveAll ? this.state.defaultCouponCodeFranchise :selection;

    this.setState({selectedFranchises: selection});
  }


  renderDefaultFranchiseFoInCR = (authUser,franchise_list,is_franchise_owner) => {
    let defaultFranchise = franchise_list.map((item) => {
      if(is_franchise_owner && 
            authUser.user.field_offices.find((office) => item.uuid === office.uuid))
      {
        return item;
      }
    });
    defaultFranchise = defaultFranchise.length ?[defaultFranchise[0]?.uuid]:[];
    if(is_franchise_owner){
      this.setState({ selectedFranchises: defaultFranchise });
      this.setState({ defaultCouponCodeFranchise: defaultFranchise });
    }
  }

  renderSingUpSecondaryFilters = () => {
    const {
      // errors,
      // zipcodes,
      // leadStatus,
      // satisfactionScore,
      stage,
      channels,
      frequency,
      outreach,
      leadStage,
      propertyType,
      customer_type,
      hearAboutUs,
      joinedEndDate,
      joinedStartDate,
      channelAttribution,
      leadCreationEndDate,
      leadCreationStartDate,
      lastServiceEndDate,
      lastServiceStartDate,
      lastContactEndDate,
      lastContactStartDate,
    } = this.state;

   if(customer_type === 'residential')
   {
     switch(stage)
     {
      case 'lead':
        return <React.Fragment>
          <div className='fitem' style={{marginTop: "30px"}}>
            <label>Lead Creation Date</label>
            <RangePicker
              allowClear
              
              format = 'MMM D, YYYY'
              value={leadCreationStartDate && leadCreationEndDate ? [moment(leadCreationStartDate), moment(leadCreationEndDate)] : ''}
              onChange = {(e) => {
                this.setDateRangeChange(e, 'lead_creation');
              }}
            />
          </div>
      
          {/* <div className='fitem'>
            <label>
              <b>Lead Status</b>
            </label>
            <Select
              value={leadStatus}
              allowClear
              mode="multiple"
              style={{ width: '100%' }}
              onChange={(e) => {this.onMultiSelectChange(e, 'leadStatus')}}
            >
              <Option key="all" value="all">All</Option>
              <Option key="active" value="active">Active</Option>
              <Option key="inactive" value="inactive">Inactive</Option>
            </Select >
          </div> */}
  
          <div className='fitem'>
            <label>
              <b>Lead stage</b>
            </label>
            <Select
              value={leadStage}
              allowClear
              mode="multiple"
              style={{ width: '100%' }}
              onChange={(e) => {this.onMultiSelectChange(e, 'leadStage')}}
            >
              <Option key="all" value="all">All</Option>
              <Option key="new" value="new">New</Option>
              <Option key="contacted" value="contacted">Contacted</Option>
              <Option key="interested" value="interested">Interested</Option>
            </Select >
          </div>
  
          <div className='fitem'>
              <label>Last Contacted Range</label>
              <RangePicker
                allowClear
                format = 'MMM D, YYYY'
                value={lastContactStartDate && lastContactEndDate ? [moment(lastContactStartDate), moment(lastContactEndDate)] : ''}
                onChange = {(e) => {
                  this.setDateRangeChange(e, "last_contact");
                }}
              />
            </div>
  
          <div className='fitem'>
            <label>
              <b>Outreach</b>
            </label>
            <Select
              allowClear
              value={outreach}
              mode="multiple"
              style={{ width: '100%' }}
              onChange={(e) => {this.onMultiSelectChange(e, 'outreach')}}
            >
              <Option key="all" value="all">All</Option>
              <Option key="call_center" value="call_center">Call Center</Option>
              <Option key="franchisee" value="franchisee">Franchisee</Option>
              <Option key="website" value="website">Website</Option>
            </Select >
          </div>
  
          <div className='fitem'>
            <label>
              <b>Channel Attribution</b>
            </label>
            <Select
              allowClear
              value={channelAttribution ? channelAttribution : 'all'}
              mode="multiple"
              style={{ width: '100%' }}
              onChange={(e) => {this.onMultiSelectChange(e, 'channelAttribution')}}
            >
              <Option key="all" value="all">All</Option>
              {
                channels.map(item => 
                  {
                    if(item.name !== 'Unknown' && item.name !== 'Spirit Magazine')
                      return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                  })
              }
            </Select >
          </div>
  
          <div className='fitem'>
            <label>
              <b>How Hear</b>
            </label>
            <Select
              value={hearAboutUs}
              allowClear
              mode="multiple"
              style={{ width: '100%', height: '100% !important' }}
              onChange={(e) => {this.onMultiSelectChange(e, 'hearAboutUs')}}
            >
              <Option key="all" value="all">All</Option>
              {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
              ))}
            </Select >
          </div>
        </React.Fragment>
     case 'signup':
       return <React.Fragment>
         <div className='fitem' style={{marginTop: "30px"}}>
           <label>Joined Date</label>
           <RangePicker
             format = 'MMM D, YYYY'
             value={joinedStartDate && joinedEndDate ? [moment(joinedStartDate), moment(joinedEndDate)] : ''}
             onChange = {(e) => {
               this.setDateRangeChange(e, 'joined');
             }}
           />
         </div>
 
         <div className='fitem'>
             <label>Last Service</label>
             <RangePicker
               format = 'MMM D, YYYY'
               value={lastServiceStartDate && lastServiceEndDate ? [moment(lastServiceStartDate), moment(lastServiceEndDate)] : ''}
               onChange = {(e) => {
                 this.setDateRangeChange(e, 'last_serviced');
               }}
             />
           </div>
     
         {/* <div className='fitem'>
             <label>
               <b>Zipcode</b>
             </label>
             <input
               type="text"
               name="zipcode"
               placeholder="Add a zipcode"
               maxLength={"5"}
               value={zipcodes}
               style={{ width: '100%' }}
               onChange={(e) => {this.setState({zipcodes: e.target.value})}}
             >
             </input >
           </div> */}
 
         <div className='fitem'>
           <label>
             <b>Frequency</b>
           </label>
           <Select
             value={frequency}
             allowClear
             mode="multiple"
             style={{ width: '100%' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'frequency')}}
           >
             <Option key="all" value="all">All</Option>
             <Option key="weekly" value="weekly">Weekly</Option>
             <Option key="monthly" value="monthly">Monthly</Option>
             <Option key="just_once<" value="once">Once</Option>
             <Option key="twice_weekly" value="twice_weekly">Twice Weekly</Option>
             <Option key="every_other_week" value="bi_monthly">Every other week</Option>
           </Select >
         </div>
 
         <div className='fitem'>
           <label>
             <b>Channel Attribution</b>
           </label>
           <Select
             allowClear
             value={channelAttribution ? channelAttribution : 'all'}
             mode="multiple"
             style={{ width: '100%' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'channelAttribution')}}
           >
             <Option key="all" value="all">All</Option>
             {
               channels.map(item => 
                 {
                   if(item.name !== 'Unknown' && item.name !== 'Spirit Magazine')
                     return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                 })
             }
           </Select >
         </div>
 
         <div className='fitem'>
           <label>
             <b>How Hear</b>
           </label>
           <Select
             value={hearAboutUs}
             allowClear
             mode="multiple"
             style={{ width: '100%', height: '100% !important'}}
             onChange={(e) => {this.onMultiSelectChange(e, 'hearAboutUs')}}
           >
             <Option key="all" value="all">All</Option>
             {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
              ))}
           </Select >
         </div>
       </React.Fragment>
     }
   }
   else if(customer_type === 'commercial')
   {
    switch(stage)
    {
      case 'lead':
        return <React.Fragment>
         <div className='fitem' style={{marginTop: "30px"}}>
           <label>Proposal Creation Date</label>
           <RangePicker
             allowClear
             format = 'MMM D, YYYY'
             value={leadCreationStartDate && leadCreationEndDate ? [moment(leadCreationStartDate), moment(leadCreationEndDate)] : ''}
             onChange = {(e) => {
               this.setDateRangeChange(e, 'lead_creation');
             }}
           />
         </div>
 
         <div className='fitem'>
           <label>
             <b>Property type</b>
           </label>
           <Select
             value={propertyType}
             allowClear
             mode="multiple"
             style={{ width: '100%' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'propertyType')}}
           >
             <Option key="all" value="all">All</Option>
             <Option key="town_homes" value="townhomes">Town Homes</Option>
             <Option key="detached_homes" value="detached">Detached homes</Option>
             <Option key="condominiums" value="condo">Condominiums</Option>
             <option key="apartments" value="apartment">Apartments</option>
           </Select >
         </div>
 
         <div className='fitem'>
           <label>
             <b>Outreach</b>
           </label>
           <Select
             allowClear
             value={outreach}
             mode="multiple"
             style={{ width: '100%' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'outreach')}}
           >
             <Option key="all" value="all">All</Option>
             <Option key="call_center" value="call_center">Call Center</Option>
             <Option key="franchisee" value="franchisee">Franchisee</Option>
             <Option key="website" value="website">Website</Option>
           </Select >
         </div>
 
         <div className='fitem'>
           <label>
             <b>Channel Attribution</b>
           </label>
           <Select
             allowClear
             value={channelAttribution ? channelAttribution : 'all'}
             mode="multiple"
             style={{ width: '100%' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'channelAttribution')}}
           >
             <Option key="all" value="all">All</Option>
             {
               channels.map(item => 
                 {
                   if(item.name !== 'Unknown' && item.name !== 'Spirit Magazine')
                     return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                 })
             }
           </Select >
         </div>
 
         <div className='fitem'>
           <label>
             <b>How Hear</b>
           </label>
           <Select
             value={hearAboutUs}
             allowClear
             mode="multiple"
             style={{ width: '100%', height: '100% !important' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'hearAboutUs')}}
           >
             <Option key="all" value="all">All</Option>
             {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
              ))}
           </Select >
         </div>
       </React.Fragment>

     case 'signup':
      return <React.Fragment>
         <div className='fitem' style={{marginTop: "30px"}}>
           <label>Joined Date</label>
           <RangePicker
             allowClear
             format = 'MMM D, YYYY'
             value={joinedStartDate && joinedEndDate ? [moment(joinedStartDate), moment(joinedEndDate)] : ''}
             onChange = {(e) => {
               this.setDateRangeChange(e, 'joined');
             }}
           />
         </div>
 
         <div className='fitem'>
           <label>
             <b>Property type</b>
           </label>
           <Select
             value={propertyType}
             allowClear
             mode="multiple"
             style={{ width: '100%' }}
             onChange={(e) => {this.onMultiSelectChange(e, 'propertyType')}}
           >
             <Option key="all" value="all">All</Option>
             <Option key="town_homes" value="townhomes">Town Homes</Option>
             <Option key="detached_homes" value="detached">Detached homes</Option>
             <Option key="condominiums" value="condo">Condominiums</Option>
             <option key="apartments" value="apartment">Apartments</option>
           </Select >
         </div>

        <div className='fitem'>
          <label>
            <b>Frequency</b>
          </label>
          <Select
            value={frequency}
            allowClear
            mode="multiple"
            style={{ width: '100%' }}
            onChange={(e) => {this.onMultiSelectChange(e, 'frequency')}}
          >
            <Option key="all" value="all">All</Option>
            <Option key="weekly" value="weekly">Weekly</Option>
            <Option key="monthly" value="monthly">Monthly</Option>
            <Option key="just_once" value="once">Just Once</Option>
            <Option key="twice_weekly" value="twice_weekly">Twice Weekly</Option>
            <Option key="every_other_week" value="bi_monthly">Every other week</Option>
          </Select >
        </div>
 
        <div className='fitem'>
          <label>
            <b>Channel Attribution</b>
          </label>
          <Select
            allowClear
            value={channelAttribution ? channelAttribution : 'all'}
            mode="multiple"
            style={{ width: '100%' }}
            onChange={(e) => {this.onMultiSelectChange(e, 'channelAttribution')}}
          >
            <Option key="all" value="all">All</Option>
            {
              channels.map(item => 
                {
                  if(item.name !== 'Unknown' && item.name !== 'Spirit Magazine')
                    return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                })
            }
          </Select >
        </div>
 
        <div className='fitem'>
          <label>
            <b>How Hear</b>
          </label>
          <Select
            value={hearAboutUs}
            allowClear
            mode="multiple"
            style={{ width: '100%', height: '100% !important' }}
            onChange={(e) => {this.onMultiSelectChange(e, 'hearAboutUs')}}
          >
            <Option key="all" value="all">All</Option>
            {aboutUsData?.map((item) => (
                <Option id={item.id} value={item.value} key={item.id}>
                  {item.name}
                </Option>
            ))}
          </Select >
        </div>
      </React.Fragment>
    }
  }
}

  renderData = () => {
    switch (this.props.id) {
      case "customer_statement": {
        let { customerList } = this.props
        return (       
          <React.Fragment>
            <div className="fitem">
              <label>
                <b>Customer</b>
              </label>
              <Select
                // defaultValue={defaultCustomer}
                value={this.state.defaultCustomer}
                showSearch
                onChange={(e) => {
                  this.setState({ defaultCustomer: e })
                  this.customerChange(e);
                }}
                filterOption={(input,option) => 
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {map(customerList, (item) => {
                  return (
                    <Option key={item.uuid} value={item.uuid} label={item.first_name + item.last_name}>{item.first_name} {item.last_name}</Option>
                  )
                })}
              </Select >
            </div>
            <div className="fitem">
              <label>
                <b>Period</b>
              </label>
              <RangePicker
                format = 'MMM D, YYYY'
                // suffixIcon={<i className="las la-angle-down"></i>}
                value={[moment(this.state.startDate), moment(this.state.endDate)]}
                onChange = {(e) => {this.setInvoiceRange(e)} }
              />  
            </div>
          </React.Fragment>
        );
      }
      
      case 'daily_log_report': {  
        const {franchise_name, is_disable_franchise} = this.props.getLoggedInUserRole();
        let { franchiseList } = this.props

        return  <React.Fragment>
          <div className="fitem">
            <label>
              <b>Franchise</b>
            </label>
            <Select
              disabled={ is_disable_franchise ? true : false}
              defaultValue={is_disable_franchise ? franchise_name : "All"}
              onChange={(e) => {
                this.franchiseChange(e);
              }}
            >
              <Option value="">All</Option>
              {map(franchiseList, (item) => {
                return(<Option key={item.id} value={item.id}>{item.name}</Option>)
              }
              )}
            </Select >
          </div>
          <div className="fitem">
            <label>
              <b>Individual Customer Rep</b>
            </label>
            <div className="fitem fitem-rinner licon">
              <div className="fitem-ricon">
                <i className="las la-search"></i>
              </div>
              <input
                type="text"
                value={this.state.searchValue}
                onChange={(e) => this.setState({
                  searchValue: e.target.value
                })}
                placeholder="Search Customer Rep"
                className="form-control flex-1" />
            </div>
          </div>
          <div className="fitem">
            <label>
              <b>Time Period</b>
            </label>
            <DatePicker
              format = 'MMM D, YYYY'
              suffixIcon={<i className="las la-angle-down"></i>}
              value={moment(this.state.endDate)}
              onChange = {(e) => {this.setTimePeriod(e)} }
            />          
          </div>
        </React.Fragment>
          
      }

      case 'in_territory_revenue_reports':{
        let { franchiseList } = this.props
        const {franchise_name, is_disable_franchise} = this.props.getLoggedInUserRole();

        return <React.Fragment>
          <div className="fitem">
            <label>
              <b>Franchise</b>
            </label>
            <Select
              disabled={ is_disable_franchise ? true : false}

              defaultValue={is_disable_franchise ? franchise_name : "All"}

              onChange={(e) => {
                this.franchiseChange(e);
              }}
            >
              <Option value="">All</Option>
              {map(franchiseList, (item) => {
                return(<Option key={item.id} value={item.id}>{item.name}</Option>)
              }
              )}
            </Select >
          </div> 
          <div className="fitem">
            <label>
              <b>Type</b>
            </label>
            <Select
              defaultValue="All"
              onChange={(e) => {
                this.setState({
                  type: e
                });
              }}
            >
              <Option value="">All</Option>
              {map(this.props.typeList, (item, i) => {
                return(<Option key={i} value={item}>{item}</Option>)
              }
              )}
            </Select >
          </div> 
        </React.Fragment>
      }

      case 'customer_complaints_report': {
        let { franchiseList } = this.props
        const {franchise_name, is_disable_franchise} = this.props.getLoggedInUserRole();

        return  <React.Fragment>
          <div className="fitem">
            <label>
              <b>Franchise</b>
            </label>
            <Select
              disabled={ is_disable_franchise ? true : false}
              defaultValue={is_disable_franchise ? franchise_name : "All"}
              onChange={(e) => {
                this.franchiseChange(e);
              }}
            >
              <Option value="">All</Option>
              {map(franchiseList, (item) => {
                return(<Option key={item.id} value={item.id}>{item.name}</Option>)
              }
              )}
            </Select >
          </div>
          <div className="fitem">
            <label>
              <b>Time Period</b>
            </label>
            <RangePicker
              format = 'MMM D, YYYY'
              suffixIcon={<i className="las la-angle-down"></i>}
              value={[moment(this.state.startDate), moment(this.state.endDate)]}
              onChange = {(e) => {this.changeTimePeriodRange(e)} }
            />          
          </div>
        </React.Fragment>
      }

      case 'invoice_revenue_report': {
        let { franchise_List } = this.props
        const {franchise_name, is_disable_franchise,franchise_uuid} = this.props.getLoggedInUserRole();
        if(is_disable_franchise)
          this.state.defaultValue = franchise_uuid
        return  <React.Fragment>
          <div className="fitem">
            <label>
              <b>Franchise <span className="required">*</span></b>
            </label>

            <Select
              disabled={ is_disable_franchise ? true : false}
              defaultValue={is_disable_franchise ? franchise_name : "Select Franchise"}
              onChange={(e) => {
                this.franchiseChange(e);
              }}
            >
              <Option value="">Select Franchise</Option>
              {map(franchise_List, (item) => {
                return(<Option key={item.id} value={item.uuid}>{item.name}</Option>)
              }
              )}
            </Select >
          </div>
          <div className="fitem">
            <label>
              <b>Time Period <span className="required">*</span></b>
            </label>
            <RangePicker
              format = 'MMM D, YYYY'
              // suffixIcon={<i className="las la-angle-down"></i>}
              value={[moment(this.state.invoiceStartDate), moment(this.state.endDate)]}
              onChange = {(e) => {this.changeTimePeriodRange("invoice", e)} }
            />
          </div>
        </React.Fragment>
      }
            
      case 'commercial_sales_report': {  
        let { franchiseList } = this.props
        const {franchise_name, is_disable_franchise} = this.props.getLoggedInUserRole();

        return  <React.Fragment>
          <div className="fitem">
            <label>
              <b>Franchise</b>
            </label>
            <Select
              disabled={ is_disable_franchise ? true : false}
              defaultValue={is_disable_franchise ? franchise_name : "All"}          
              onChange={(e) => {
                this.franchiseChange(e);
              }}
            >
              <Option value="">All</Option>
              {map(franchiseList, (item) => {
                return(<Option key={item.id} value={item.id}>{item.name}</Option>)
              }
              )}
            </Select >
          </div>
          <div className="fitem">
            <label>
              <b>Individual BDO</b>
            </label>
            <div className="fitem fitem-rinner licon">
              <div className="fitem-ricon">
                <i className="las la-search"></i>
              </div>
              <input
                type="text"
                value={this.state.searchValue}
                onChange={(e) => this.setState({
                  searchValue: e.target.value
                })}
                placeholder="Search BDO"
                className="form-control flex-1" />
            </div>
          </div>
          <div className="fitem">
            <label>
              <b>Time Period</b>
            </label>
            <RangePicker
              defaultValue={[moment(this.state.startDate), moment(this.state.endDate)]}
              format='MMM D, YYYY'
              onChange = {(e) => {this.setInvoiceRange(e)} }
            />

          </div>
        </React.Fragment>
      }

      case "customer_price_increase_report":  {
        let { franchise, userRoles,isValid } = this.props;
        const {franchise_name,is_disable_franchise, franchise_uuid} = this.props.getLoggedInUserRole();
        if(is_disable_franchise)
          this.state.defaultValue = franchise_uuid
        return (
          <React.Fragment>
            
            {
            //this report will always execlude 
            /*
            <div className="fitem">
              <label>
                <Checkbox
                  checked={this.state.isCheck}
                  onChange={(e) => {
                    this.setState({ isCheck: e.target.checked });
                  }}
                  className="font-weight-bold"
                >
                    Exclude Customers in a pre-pay period
                </Checkbox>
              </label>
            </div>
            */}
            <div className="fitem">
              <label>
                  <b>
                    Franchise <span className="required">*</span>
                  </b>
              </label>
              <Select
                disabled={ is_disable_franchise ? true : false}
                defaultValue={is_disable_franchise ? franchise_name : franchise[0]!== undefined?franchise[0].id:""}   
                onChange={(e) => {
                  this.franchiseChange(e);
                }}
              >
                {
                  //<Option value="">All</Option>
                }
                {franchise.sort((a, b) => a.name > b.name ? 1:-1).map((item, i) => {
                  return (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
              {isValid?<span className="required">Please choose any Franchise!</span>:null}
            </div>
            <div className="fitem">
              <label>
                <b>Customer Type</b>
              </label>
              <Select
                defaultValue="All"
                onChange={(e) => {
                  this.userRoleChange(e);
                }}
              >
                <Option value="">All</Option>
                {map(userRoles, (item) => {
                  return (
                    <Option key={item} value={item}>
                      {item?.charAt(0).toUpperCase() + item?.substr(1)}
                    </Option>
                  );
                })}
              </Select>
            </div>

           
            <div className="fitem">
              <label>
                <b>Joined</b>
              </label>
              <Select
                defaultValue="All"
                onChange={(e) => {
                  this.joinedChange(e);
                }}
              >
                <Option value="">All</Option>
                <Option key={1} value={moment().subtract(6, 'months').format('YYYY-MM-DD')}>
                        Prior to 6 Months
                </Option>
                <Option key={2} value={moment().subtract(1, 'years').format('YYYY-MM-DD')}>
                        Prior to 1 Year
                </Option>
                <Option key={3} value={moment().subtract(3, 'years').format('YYYY-MM-DD')}>
                        Prior to 3 Years
                </Option>
                <Option key={5} value= 'custom'>
                  Custom
                </Option>
              </Select>
            </div>
            {this.state.joined == 'custom' ?
              <div className="fitem">
                <label>
                  <b>Custom Joined date</b>
                </label>
                <RangePicker
                  format = 'MMM D, YYYY'
                  onChange = {(e) => {this.customJoinedDateChange(e)} }
                />
              </div>
            : <></>
            }  
            <div className="fitem">
              <label>
                <b>Last Increased</b>
              </label>

              <RangePicker
                format = 'MMM D, YYYY'
                onChange = {(e) => {this.setLastIncrease(e)} }
              />
            </div>
            <div className="fitem">
              <label>
                <b>Satisfaction Score</b>
              </label>
              <Select
                defaultValue="All"
                onChange={(e) => {
                  this.satisfactionScoreChange(e);
                }}
              >
                <Option value="">All</Option>
                <Option value="25">Over 25%</Option>
                <Option value="50">Over 50%</Option>
                <Option value="75">Over 75%</Option>
                <Option value="95">Over 95%</Option>
                <Option value="100">100%</Option>
              </Select>
            </div>
            <div className="fitem">
              <label>
                <b>No Complaints Since</b>
              </label>
              <Select
                defaultValue="Any Time"
                onChange={(e) => {
                  this.lastComplaintChange(e);
                }}
              >
                <Option value="">Any Time</Option>
                <Option value={`${moment().subtract(1, 'months').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`}>Past 1 Month</Option>
                <Option value={`${moment().subtract(3, 'months').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`}>Past 3 Months</Option>
                <Option value={`${moment().subtract(6, 'months').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`}>Past 6 Months</Option>
                <Option value={`${moment().subtract(1, 'years').format('YYYY-MM-DD')},${moment().format('YYYY-MM-DD')}`}>Past 1 Year</Option>
              </Select>
            </div>
            <div className="fitem">
              <label>
                <b>Date of First Service</b>
              </label>
              <RangePicker
                format = 'MMM D, YYYY'
                onChange = {(e) => {this.setFirstServiceRange(e)} }
              />
            </div>
          </React.Fragment>
        );
      }

      case 'customer-cancelation-report': {
        const { 
          authUser,
          summaryReports,
          total_cancelation_customer,
          franchise_list,
          selectedFranchises,
          errors,
          cancellationReason
        } =this.state;
        const is_corparate_user = authUser?.user?.user_roles.map(x => x.name).includes("admin");
        const is_franchise_owner = authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");

        return <React.Fragment>
          <h3>Filter</h3>
          <div className="fitem">
            <label>
              <b>Cancellation Date Range<span className="required">*</span></b>
            </label>
            <RangePicker
              format = 'MMM D, YYYY'
              value={[moment(this.state.periodStartDate), moment(this.state.periodEndDate)]}
              onChange = {(e) => {this.changePeriodDateRange("period",e)} }
            />
          </div>
          <div className='fitem'>
            <label>
              <b>Franchise</b>
            </label>
            <Select
              mode="multiple"
              allowClear
              value={selectedFranchises ? selectedFranchises : 'All'}
              style={{ width: '100%' }}
              onChange={(e) => {this.onSelectedFranchisesChange(e)}}
            >
              {
                is_corparate_user || (is_franchise_owner && franchise_list.length > 1) ?
                  <Option key="All" value="All">All</Option> : null
              }
              {
                is_corparate_user ? 
                  franchise_list.map((item) => {
                    return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                  }) :  
                  franchise_list.map((item) => {
                    if(is_franchise_owner && 
                          authUser.user.field_offices.find((office) => item.uuid === office.uuid))
                    {
                      return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                    }
                  })
              }
            </Select >
          </div>
          <div className="fitem">
            <label>
              <b>Reason for cancellation<span className="required">*</span></b>
            </label>
            <Select
              value={cancellationReason}
              defaultValue=""
              onChange={(e) => {
                this.setState({
                  cancellationReason: e
                });
              }}
            >
              <Option value="">All</Option>
              <Option value="death_of_dog">Loss of Pet</Option>
              <Option value="service">Service Quality</Option>
              <Option value="moving">Moving</Option>
              <Option value="competition">Pricing</Option>
              <Option value="other">Other</Option>   
            </Select >
          </div>
          <hr />
          <br />
          <div className="fitem">
            <label>
              <h4 style={{textAlign: "center"}}>Cancellation Summary</h4>
            </label>
          </div>
          <div className="card-body">
            <Table
              rowKey={record => record.id}
              dataSource={summaryReports}
              columns={DataTable.CancellationSummary(this)}
              className="table hscroll report-tbl border-around inner-table"
              pagination={false} 
            />
          </div>
          <br />
          <div className="fitem">
            <label>
              <h4 style={{textAlign: "center"}}>Total Cancellations : {total_cancelation_customer}</h4>
            </label>
          </div>
        </React.Fragment>
      }

      case 'royalty-report': {
        const { authUser, franchise_list, selectedFranchises } =this.state;
        const is_corparate_user = authUser?.user?.user_roles.map(x => x.name).includes("admin");
        const is_franchise_owner = authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");

        return <React.Fragment>
          <div className='fitem'>
            <label>Time Period<sup>*</sup></label>
            <RangePicker
              format = 'MMM D, YYYY'
              value={[moment(this.state.reportStartDate), moment(this.state.reportEndDate)]}
              onChange = {(e) => {
                this.setReportDateRange(e);
              }}
            />
          </div>
          <div className='fitem'>
            <label>Franchise</label>
            <Select
              allowClear
              mode="multiple"
              defaultValue={"All"}
              style={{ width: '100%' }}
              value={selectedFranchises ? selectedFranchises : 'All'}
              onChange={(e) => {this.onSelectedFranchisesChange(e)}}
            >
              {
                is_corparate_user || (is_franchise_owner && franchise_list.length > 1) ? 
                  <Option key="All" value="All">All</Option> : null
              }
              {
                is_corparate_user ? 
                  franchise_list.map((item) => {
                    return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                  }) :  
                  franchise_list.map((item) => {
                    if(is_franchise_owner && 
                          authUser.user.field_offices.find((office) => item.uuid === office.uuid))
                    {
                      return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                    }
                  })
              }
            </Select >
          </div>
        </React.Fragment>
      }

      case 'lead_signup_report': {
        // let { franchiseList } = this.props;
        const { 
          authUser,
          stage,
          franchise_list,
          selectedFranchises,
          errors,
          customer_type,
        } =this.state;
        const is_corparate_user = authUser?.user?.user_roles.map(x => x.name).includes("admin");
        const is_franchise_owner = authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");

        return <React.Fragment>
          <div className='fitem'>
            <label>
              <b>Franchise</b>
            </label>
            <Select
              mode="multiple"
              allowClear
              value={selectedFranchises ? selectedFranchises : 'All'}
              style={{ width: '100%' }}
              onChange={(e) => {this.onSelectedFranchisesChange(e)}}
            >
              {
                is_corparate_user || (is_franchise_owner && franchise_list.length > 1) ?
                  <Option key="All" value="All">All</Option> : null
              }
              {
                is_corparate_user ? 
                  franchise_list.map((item) => {
                    return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                  }) :  
                  franchise_list.map((item) => {
                    if(is_franchise_owner && 
                          authUser.user.field_offices.find((office) => item.uuid === office.uuid))
                    {
                      return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                    }
                  })
              }
            </Select >
          </div>

          <div className="fitem">
            <label>
              <b>Customer Type</b>
            </label>
            <Select
              value={customer_type !== '' ? customer_type : null}
              onChange={(e) => {
                this.setState({customer_type: e, errors: {}});
                if(customer_type !== '')
                {
                  this.resetFilters(false, true);
                }
              }}
              placeholder="Please select an option"
            >
              <Option key="commercial" value="commercial"> Commercial </Option>
              <Option key="residential" value="residential"> Residential </Option>
            </Select >
          </div>
          {
            Object.keys(errors).length > 0  && customer_type === '' ? 
              <label className="new_err_msg"><i className="las la-info-circle"></i>{errors?.customer_type}</label> : null
          }
          {
            customer_type && customer_type != '' &&
            <div className="fitem">
              <label>
                <b>Stage</b>
              </label>
              <Select
                value={stage !== '' ? stage : null}
                onChange={(e) => {
                  this.setState({stage: e, errors: {}});
                  if(stage !== '')
                  {
                    this.resetFilters(true);
                  }
                }}
                placeholder="Please select an option"
              >
                <Option key={"lead"} value={"lead"}>{customer_type === 'residential' ? "Lead" : "Proposal"} </Option>
                <Option key="signup" value="signup"> Sign Up </Option>
              </Select >
            </div>
          }
          {
            Object.keys(errors).length > 0  && customer_type !== '' && stage === '' ? 
              <label className="new_err_msg"><i className="las la-info-circle"></i>{errors?.stage}</label> : null
          }
          {
            stage && stage !== '' && this.renderSingUpSecondaryFilters()
          }

        </React.Fragment>
      }

      case 'coupon_report': {
        // let { franchiseList } = this.props;
        const { authUser, franchise_list, errors, couponType, selectedFranchises } =this.state;
        const is_corparate_user = authUser?.user?.user_roles.map(x => x.name).includes("admin");
        const is_franchise_owner = authUser?.user?.user_roles.map(x => x.name).includes("franchise_owner");
        return <React.Fragment>
          <div className='fitem'>
            <label>
              <b>Franchise</b>
            </label>
            <Select
              mode="multiple"
              allowClear={false}
              defaultValue={"All"}
              value={selectedFranchises}
              style={{ width: '100%' }}
              onChange={(e) => {this.onSelectedFranchisesChange(e)}}
            >
              {
                is_corparate_user || (is_franchise_owner && franchise_list.length > 1) ? 
                  <Option key="All" value="All">All</Option> : null
              }
              {
                is_corparate_user ? 
                  franchise_list.map((item) => {
                    return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                  }) :  
                  franchise_list.map((item) => {
                    if(is_franchise_owner && 
                          authUser.user.field_offices.find((office) => item.uuid === office.uuid))
                    {
                      return <Option key={item.id} value={item.uuid}>{item.name}</Option>
                    }
                  })
              }
            </Select >
          </div>
          <div className="fitem">
            <label>
              <b>Coupon Type</b>
            </label>
            <Select
              mode="multiple"
              allowClear={false}
              value={couponType}
              defaultValue={'all'}
              onChange={(e) => {this.onMultiSelectChange(e, 'couponType')}}
            >
              <option selected key="all" value='all'>All</option>
              <Option key="perc_off_init_clean" value="perc_off_init_clean"> % Off initial cleaning </Option>
              <Option key="dollar_off_services" value="dollar_off_services"> Dollar off for services </Option>
              <Option key="perc_off_services" value="perc_off_services"> % Off for services </Option>
              <Option key="free_gift" value="free_gift"> Free gift </Option>
            </Select >
          </div>
          {
            Object.keys(errors).length > 0 ? 
              <label className="new_err_msg"><i className="las la-info-circle"></i>{errors?.coupon}</label> : null
          }

          {/* Customer Sign Up Date */}
          <div className='fitem'>
            <label>Customer Sign Up Date<sup>*</sup></label>
            <RangePicker
              format = 'MMM D, YYYY'
              allowClear={true}
              value={this.state.reportStartDate ? [moment(this.state.reportStartDate), moment(this.state.reportEndDate)] : ''}
              onChange = {(e) => {
                this.setReportDateRange(e, 'coupon-report');
              }}
            />
          </div>
        </React.Fragment>
      }

      default: {
        return this.props.history.push("/reports");
      }
    }
  }

  renderButtonData = () => {
    switch (this.props.id) 
    {
      case "customer_statement": {
        return <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
              Reset
          </button>

          <button type="button" className="btn btn-primary" onClick={() => {
            this.props.updateCustomerDetails({
              customerId: this.state.customerId
            })
            this.props.buildReport(this.state.customerId,`${this.state.startDate},${this.state.endDate}`)
          }
          }>
              Build Report
          </button>
        </div>
      }
    
      case 'daily_log_report': {  
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
              Reset
          </button>
        
          <button type="button" className="btn btn-primary" onClick={() => this.props.buildReport({
            franchise_id: this.state.defaultValue,
            search: this.state.searchValue,
            created_at__date: this.state.endDate
          })}>
              Build Report
          </button>
        </div>
      }

      case 'in_territory_revenue_reports':{
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
            Reset
          </button>
      
          <button type="button" className="btn btn-primary" onClick={() => this.props.buildReport({
            id: this.state.defaultValue,
            type: this.state.type
          })}>
            Build Report
          </button>
        </div>
      }

      case 'customer_complaints_report': {
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
              Reset
          </button>
        
          <button type="button" className="btn btn-primary" onClick={() => this.props.buildReport({
            id: this.state.defaultValue,
            date_range: `${this.state.startDate},${this.state.endDate}`
          })}>
              Build Report
          </button>
        </div>
      }

      case 'invoice_revenue_report': {
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
              Reset
          </button>
        
          <button type="button" className="btn btn-primary" onClick={() => this.props.buildReport({
            id: this.state.defaultValue,            
            date_range: `${this.state.invoiceStartDate},${this.state.endDate}`
          })}>
              Build Report
          </button>
        </div>
      }

      case 'commercial_sales_report': {
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
              Reset
          </button>
        
          <button type="button" className="btn btn-primary" onClick={() => {
            this.props.buildReport({
              id: this.state.defaultValue,
              search: this.state.searchValue,
              serviceorder__created_at__date__range: `${this.state.startDate},${this.state.endDate}`
            })
          }
          }>
              Build Report
          </button>
        </div>
      }

      case "customer_price_increase_report": {
        return (
          <div className="btn-grp">
            <button
              type="button"
              className="btn btn-brand btn-bdr"
              onClick={() => this.props.resetFilters()}
            >
                Reset
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                const {is_disable_franchise} = this.props.getLoggedInUserRole();
                let params = {
                  is_prepaid: this.state.isCheck,
                  service_type: this.state.userRole,
                  // last_increase__range: `${this.state.startDate},${this.state.endDate}`,
                  satisfaction_score: this.state.satisfactionScore,
                  // first_service: `${this.state.firstServiceStartDate},${this.state.firstServiceEndDate}`
                }
                if (is_disable_franchise) {
                  Object.assign(params, {field_office_uuid: this.state.defaultValue});
                }else{
                  Object.assign(params, {field_office_id: this.state.defaultValue});
                }
                if (this.state.last_increase_startDate && this.state.last_increase_endDate) {
                  Object.assign(params, {last_increase__range: `${this.state.last_increase_startDate},${this.state.last_increase_endDate}`});
                }

                if (this.state.firstServiceStartDate && this.state.firstServiceEndDate) {
                  Object.assign(params, {first_service: `${this.state.firstServiceStartDate},${this.state.firstServiceEndDate}`});
                }
                // get joined filter 
                if (this.state.joined != 'All'){
                  if(this.state.joined == 'custom'){
                    if (this.state.customJoinedStartDate && this.state.customJoinedEndDate) {
                      Object.assign(params, {joined_date: `${this.state.customJoinedStartDate},${this.state.customJoinedEndDate}`});
                    }
                  }
                  else{
                    Object.assign(params, {prior_joined_date: this.state.joined})
                  }
                }
                if (this.state.lastComplaint) {
                  /*
                    AUTHOR: Ritesh
                    Changed 30-09-2021 (Thursday)
                    <DOOD-3052>As per this ticket we are going to pass both the filters</DOOD-3052>
                    delete params.last_increase__range
                    */
                  Object.assign(params, {last_complaint: this.state.lastComplaint})
                }
                

                let filters = Object.keys(params)
                  .filter((k) => params[k] !== '')
                  .reduce((a, k) => ({ ...a, [k]: params[k] }), {});
                this.props.buildReport(filters)
              }

              }
            >
                Build Report
            </button>
          </div>
        );
      }

      case 'customer-cancelation-report':{
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
            Reset
          </button>
      
          <button type="button" className="btn btn-primary" onClick={() => this.onBuildReport()}>
            Build Report
          </button>
        </div>
      }

      case 'royalty-report': {
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
            Reset
          </button>
      
          <button type="button" className="btn btn-primary" onClick={() => this.onBuildReport() }>
            Build Report
          </button>
        </div>
      }

      case 'lead_signup_report': {
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
          Reset
          </button>
    
          <button type="button" className="btn btn-primary" onClick={() => this.onBuildReport()}>
            Build Report
          </button>
        </div>
      }

      case 'coupon_report': {
        return     <div className="btn-grp">
          <button type="button" className="btn btn-brand btn-bdr" onClick={() => this.props.resetFilters()}>
            Reset
          </button>
      
          <button type="button" className="btn btn-primary" onClick={() => this.onBuildReport()}>
            Build Report
          </button>
        </div>
      }

      default: {
        return <div></div>
      }
    }

  }

  render() {
    let { loader } = this.state;
    let { title, isValid , id } = this.props;
    return (
      <aside className="laside fo-side d-flex flex-column justify-content-between">
        <div className="w-100">
          <h4>{title}</h4>
          <div className="form-group">{this.renderData()}</div>
          {id !== "customer_price_increase_report" && isValid?<span className="required">Please choose any Franchise!</span>:null}
        </div>
        <div className="d-flex justify-content-end w-100">
          {this.renderButtonData()}
        </div>
        {loader ? <Loader /> : ""}
      </aside>
    );
  }
}

export default ReportSidebar;